import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

const { REQUIRED } = ERROR_TYPE;

// Small self-contained response schemas, extracted from list.ts so that (over-length) file stays
// within the architecture-gate ratchet. Re-exported from list.ts so existing imports keep working.
export const NorthdataSchema = z.object({
	id: z.number(),
	name: z.string().min(4, { message: REQUIRED }).trim(),
	url: z.string().min(4, { message: REQUIRED }).trim(),
});

export const LemlistSchema = z.object({
	id: z.number(),
	status: z.string(),
	name: z.string().min(4, { message: REQUIRED }).trim(),
	labels: z.string(),
});

export const BulkAssignResponseSchema = z.object({
	status: z.string(),
	reviewSessionId: z.number().optional(),
	assigned: z.number().optional(),
	skippedPlaceholders: z.number().optional(),
	failed: z.number().optional(),
	/** Leads left out as already connected to the senders (PREC-4426). */
	skippedConnected: z.number().optional(),
});

export const ArchiveResponseSchema = z.object({
	status: z.string(),
	/** PREC-4537: lists the API refused to archive/delete, each with its reason code. */
	refused: z
		.array(
			z.object({
				id: z.number(),
				reason: z.string(),
			})
		)
		.optional(),
});
